<template>
    <div>
        <div class="row d-flex d-lg-none">
            <div class="col text-center">
                <p class="font-weight-bold text-muted">Your data is secure with us <img src="../../assets/images/SSL_secure_icon.svg" alt=""></p>
            </div>
        </div>
        <div class="row d-flex d-lg-none">
            <div class="col text-center">
                <img src="../../assets/images/directdebit.png" alt="" class="direct-debit float-none">
                <p class="pt-3 mb-1">Simple convenient and safe.</p>
                <p class="mb-1">Direct Debit is automated payment method that is used by majority of UK households.</p>
                <p class="mb-1">The Direct Debit Guarantee apply to all direct debits.</p>
                <p class="mb-1"><a
                    href="https://www.directdebit.co.uk/DirectDebitExplained/pages/directdebitguarantee.aspx">Direct
                    Debit Guarantee</a></p>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-6">
                <div class="form-group">
                    <label for="holderName">Name of account holder</label>
                    <input type="text" id="holderName" v-model.trim="$v.accountName.$model"
                           class="form-control form-control-lg" :class="{'is-invalid' : $v.accountName.$error || errors.accountName.length }">
                    <div class="invalid-feedback" v-if="!$v.accountName.required">
                        Please enter account holder name
                    </div>
                    <div class="invalid-feedback" v-for="(err, key) in errors.accountName" :key="key">
                        {{err}}
                    </div>
                </div>
                <div class="form-group">
                    <label for="accountNumber">Bank/Building Society account number</label>
                    <input type="text" id="accountNumber" v-model.trim="$v.accountNumber.$model"
                           class="form-control form-control-lg" :class="{'is-invalid' : $v.accountNumber.$error || errors.accountNumber.length}">
                    <div class="invalid-feedback" v-if="!$v.accountNumber.required">
                        Please enter account number
                    </div>
                    <div class="invalid-feedback " v-if="(!$v.accountNumber.minLength || !$v.accountNumber.maxLength)">
                        Account number should be between 6 and 8 digits
                    </div>
                    <div class="invalid-feedback " v-if="!$v.accountNumber.numeric">
                        Account number should be numeric
                    </div>
                    <div class="invalid-feedback" v-for="(err, key) in errors.accountNumber" :key="key">
                        {{err}}
                    </div>
                </div>
                <div class="form-group">
                    <label for="branchCode1">Branch sort code</label>
                    <div class="d-flex justify-content-center align-items-center w-100"
                         :class="{'is-invalid' : $v.bankSortCode.$error || errors.bankSortCode.length}">
                        <input type="text" id="branchCode1" ref="branchCodeSegmentFirst"
                               v-model.trim="$v.bankSortCodeFirst.$model"
                               class="branch-code-segment form-control form-control-lg flex-fill w-25"
                               :class="{'is-invalid' : $v.bankSortCodeFirst.$error}"
                               maxlength="2" @input="handleFirstBranchSegment">
                        <span class="mx-2">-</span>
                        <input type="text" id="branchCode2" ref="branchCodeSegmentSecond"
                               v-model.trim="$v.bankSortCodeSecond.$model"
                               class="branch-code-segment form-control form-control-lg flex-fill w-25"
                               :class="{'is-invalid' : $v.bankSortCodeSecond.$error}"
                               maxlength="2" @input="handleSecondBranchSegment">
                        <span class="mx-2">-</span>
                        <input type="text" id="branchCode3" ref="branchCodeSegmentThird"
                               v-model.trim="$v.bankSortCodeThird.$model"
                               class="branch-code-segment form-control form-control-lg flex-fill w-25"
                               :class="{'is-invalid' : $v.bankSortCodeThird.$error}"
                               maxlength="2" @input="handleThirdBranchSegment">
                    
                    </div>
                    <div class="invalid-feedback " v-if="(!$v.bankSortCode.minLength || !$v.bankSortCode.maxLength)">
                        Bank sort code should be exactly 6 digits
                    </div>
                    <div class="invalid-feedback " v-if="!$v.bankSortCode.numeric">
                        Bank sort code should be numeric
                    </div>
                    <div class="invalid-feedback" v-for="(err, key) in errors.bankSortCode" :key="key">
                        {{err}}
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 d-none d-lg-block">
                <div class="row">
                    <div class="col text-right">
                        <p class="font-weight-bold text-muted">Your data is secure with us <img src="../../assets/images/SSL_secure_icon.svg" alt=""></p>
                    </div>
                </div>
                <div class="overflow-hidden">
                    <img src="../../assets/images/directdebit.png" alt="" class="direct-debit">
                </div>
                <div>
                    <p class="pt-3 text-right">Simple convenient and safe.</p>
                    <p>Direct Debit is automated payment method that is used by majority of UK households.</p>
                    <p>The Direct Debit Guarantee apply to all direct debits.</p>
                    <p class="text-right"><a
                        href="https://www.directdebit.co.uk/DirectDebitExplained/pages/directdebitguarantee.aspx"
                        target="_blank">Direct Debit Guarantee</a></p>
                </div>
            </div>
        </div>
        <hr v-if="!update">
        <div class="row mt-4" v-if="!update">
            <div class="col">
                <h5>Your contact details</h5>
                <div class="row">
                    <div class="col-12">
                        <p>Contact name</p>
                    </div>
                    <div class="col-12 col-lg-2">
                        <label for="title">Title</label>
                        <select id="title" required v-model.trim="$v.title.$model"
                                class="custom-select custom-select-lg" :class="{'is-invalid' : $v.title.$error || errors.title.length}">
                            <option value="" disabled selected hidden>Title</option>
                            <option v-for="(ttl , k) in titles" :key="k">{{ ttl }}</option>
                        </select>
                        <div class="invalid-feedback" v-if="$v.title.$dirty && !$v.title.$required">
                            Please tell us your title!
                        </div>
                        <div class="invalid-feedback" v-for="(err, key) in errors.title" :key="key">
                            {{err}}
                        </div>
                    </div>
                    <div class="col-12 col-lg-5">
                        <div class="form-group">
                            <label for="firstName">First Name</label>
                            <input type="text" id="firstName" class="form-control  form-control-lg"
                                   v-model="$v.firstName.$model" :class="{'is-invalid' : $v.firstName.$error || errors.first_name.length}">
                            <div class="invalid-feedback" v-if="!$v.firstName.$required">
                                Please enter your first name!
                            </div>
                            <div class="invalid-feedback" v-for="(err, key) in errors.first_name" :key="key">
                                {{err}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-5">
                        <div class="form-group">
                            <label for="lastName">Last Name</label>
                            <input type="text" id="lastName" class="form-control form-control-lg "
                                   v-model="$v.lastName.$model" :class="{'is-invalid' : $v.lastName.$error || errors.last_name.length}">
                            <div class="invalid-feedback" v-if="!$v.lastName.$required">
                                Please enter your last name!
                            </div>
                            <div class="invalid-feedback" v-for="(err, key) in errors.bankSortCode" :key="key">
                                {{err}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <p>Your switching address</p>
                        <p>{{ currentAddress }}, {{ currentPostcode }}</p>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="differentAddress"
                                   v-model="differentAddress">
                            <label class="custom-control-label" for="differentAddress">Add different contact
                                address</label>
                        </div>
                        <collapse-transition>
                            <div class="form py-4" v-if="differentAddress">
                                <div class="form-group">
                                    <label for="subBuildingNumberName">Sub-building number/name</label>
                                    <input type="text" id="subBuildingNumberName"
                                           v-model.trim="$v.subBuildingNumberName.$model"
                                           class="form-control form-control-lg"
                                           :class="{'is-invalid' : $v.subBuildingNumberName.$error || errors.subBuildingNumberName.length}">
    
                                    <div class="invalid-feedback" v-for="(err, key) in errors.subBuildingNumberName" :key="key">
                                        {{err}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="buildingNumberName">Building number/name</label>
                                    <input type="text" id="buildingNumberName"
                                           v-model.trim="$v.buildingNumberName.$model"
                                           class="form-control form-control-lg"
                                           :class="{'is-invalid' : $v.buildingNumberName.$error || errors.buildingNumberName.length}">
    
                                    <div class="invalid-feedback" v-for="(err, key) in errors.buildingNumberName" :key="key">
                                        {{err}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="streetAddress">Street address</label>
                                    <input type="text" id="streetAddress" v-model.trim="$v.streetAddress.$model"
                                           class="form-control form-control-lg"
                                           :class="{'is-invalid' : $v.streetAddress.$error || errors.streetAddress.length}">
                                    <div class="invalid-feedback" v-if="!$v.streetAddress.required">
                                        Please enter street address!
                                    </div>
    
                                    <div class="invalid-feedback" v-for="(err, key) in errors.streetAddress" :key="key">
                                        {{err}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="postCode">Post code</label>
                                    <input type="text" id="postCode" v-model.trim="$v.postCode.$model"
                                           class="form-control form-control-lg"
                                           :class="{'is-invalid' : $v.postCode.$error || errors.postcode.length}">
                                    <div class="invalid-feedback" v-if="!$v.postCode.required">
                                        Please enter post code!
                                    </div>
                                    <div class="invalid-feedback" v-if="!$v.postCode.validPostCode">
                                        Please enter a valid post code!
                                    </div>
    
                                    <div class="invalid-feedback" v-for="(err, key) in errors.postcode" :key="key">
                                        {{err}}
                                    </div>
                                </div>
                            </div>
                        </collapse-transition>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label for="phoneNumber">Phone number</label>
                            <div class="input-group input-group-lg mb-3"
                                 :class="{'is-invalid' : $v.accountPhone.$error || errors.accountPhone.length }">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="phonecode_addon">+44</span>
                                </div>
                                <input type="text" id="phoneNumber" class="form-control"
                                       aria-describedby="phonecode_addon"
                                       v-model.trim="$v.accountPhone.$model"
                                       :class="{'is-invalid' : $v.accountPhone.$error}">
                            </div>
                            
                            <div class="invalid-feedback" v-if="!$v.accountPhone.required">
                                Please enter your phone number!
                            </div>
                            <div class="invalid-feedback" v-if="!$v.accountPhone.validPhone">
                                Please enter a valid phone number!
                            </div>
    
                            <div class="invalid-feedback" v-for="(err, key) in errors.accountPhone" :key="key">
                                {{err}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        
        </div>
        <hr>
        <div class="row mt-4" v-if="!update">
            <div class="col">
                <p>As part of the switching process we'll pass your details to your new energy supplier, so they can
                    bill you when the switch has been completed.</p>
                <div class="form-group">
                    <div class="custom-control custom-checkbox" :class="{'is-invalid': $v.confirmHolder.$error }">
                        <input type="checkbox" class="custom-control-input" id="confirm"
                               v-model="$v.confirmHolder.$model"
                               :class="{'is-invalid': $v.confirmHolder.$error }">
                        <label class="custom-control-label" for="confirm">
                            I confirm that I am the account holder and am authorised to set up Direct Debit payments on
                            this account.
                        </label>
                    </div>
                    <div class="invalid-feedback" v-if="!$v.confirmHolder.isChecked">
                        Please confirm that you are the account holder and you are authorised to setup Direct Debit
                        payments!
                    </div>
                </div>
                <div class="form-group">
                    <div class="custom-control custom-checkbox" :class="{'is-invalid': $v.confirmTos.$error }">
                        <input type="checkbox" class="custom-control-input" id="agree" v-model="$v.confirmTos.$model"
                               :class="{'is-invalid': $v.confirmTos.$error }">
                        <label class="custom-control-label" for="agree">
                            I have read, understand and agree to MySwitchPro the
                            <router-link to="/terms">Terms and Conditions</router-link>
                        </label>
                    </div>
                    <div class="invalid-feedback" v-if="!$v.confirmTos.isChecked">
                        Please confirm that you have read, understood and agreed to our Terms and Conditions
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {CollapseTransition} from 'vue2-transitions'
import {validationMixin} from 'vuelidate'
import {maxLength, minLength, numeric, required} from 'vuelidate/lib/validators'
import api from "@/utils/api";
import {each} from 'lodash'
const PhoneNumber = require('awesome-phonenumber');
const postCodeRegex = new RegExp('([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\\s?[0-9][A-Za-z]{2})')
const titles = [
    'Mr', 'Mrs', 'Ms', 'Miss'
]
const validPhone = (value) => {
    if (!value) {
        return false;
    }
    let pn = PhoneNumber(`+44${value}`, 'GB')
    return pn.isValid();
}
const validPostCode = (value) => postCodeRegex.test(value)
const isChecked = (value) => value === true
export default {
    name: "DirectDebitForm",
    mixins: [validationMixin],
    components: {CollapseTransition},
    props: {
        update: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            titles: titles,
            title: this.$store.getters['auth/title'] || '',
            firstName: this.$store.getters['auth/firstName'] || '',
            lastName: this.$store.getters['auth/lastName'] || '',
            accountName: null,
            accountPhone: this.$store.getters['auth/phone']?.replace("+44",'') || '',
            accountNumber: null,
            bankSortCodeFirst: null,
            bankSortCodeSecond: null,
            bankSortCodeThird: null,
            subBuildingNumberName: null,
            buildingNumberName: null,
            streetAddress: null,
            postCode: null,
            differentAddress: false,
            confirmHolder: null,
            confirmTos: null,
            currentAddress: null,
            currentPostcode: null,
            recommendationSavings: null,
            errors: {
                title: [],
                first_name: [],
                last_name: [],
                accountName: [],
                accountPhone: [],
                accountNumber: [],
                bankSortCode: [],
                subBuildingNumberName: [],
                buildingNumberName: [],
                streetAddress: [],
                postcode: [],
                differentAddress: [],
            }
        }
    },
    validations: function () {
        const nameValidators = {
            title: {
                required
            },
            firstName: {
                required
            },
            lastName: {
                required
            }
        }
        const accountValidators = {
            accountName: {
                required
            },
            
            accountNumber: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(8),
                numeric
            },
            bankSortCodeFirst: {
                required
            },
            bankSortCodeSecond: {
                required
            },
            bankSortCodeThird: {
                required
            },
            bankSortCode: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(6),
                numeric
            }
        }
        
        const confirmValidators = {
            confirmHolder: {
                isChecked
            },
            confirmTos: {
                isChecked
            }
        }
        
        const addressValidators = {
            subBuildingNumberName: {},
            buildingNumberName: {},
            streetAddress: {
                required
            },
            postCode: {
                required,
                validPostCode
            },
        }
        if (this.update) {
            return accountValidators
        }
        if (this.differentAddress) {
            return {
                ...accountValidators,
                ...nameValidators,
                accountPhone: {
                    required,
                    validPhone
                },
                ...confirmValidators,
                ...addressValidators
            }
        }
        return {
            ...accountValidators,
            ...nameValidators,
            accountPhone: {
                required,
                validPhone
            },
            ...confirmValidators
        }
    },
    computed: {
        bankSortCode() {
            return `${this.bankSortCodeFirst}${this.bankSortCodeSecond}${this.bankSortCodeThird}`;
        }
    },
    methods: {
        handleFirstBranchSegment(e) {
            if (e.target.value.length === 2) {
                this.$refs.branchCodeSegmentSecond.focus()
            }
        },
        // eslint-disable-next-line no-unused-vars
        handleSecondBranchSegment(e) {
            if (e.target.value.length === 2) {
                this.$refs.branchCodeSegmentThird.focus()
            }
            if (e.target.value.length === 0) {
                this.$refs.branchCodeSegmentFirst.focus()
            }
        },
        // eslint-disable-next-line no-unused-vars
        handleThirdBranchSegment(e) {
            if (e.target.value.length === 0) {
                this.$refs.branchCodeSegmentSecond.focus()
            }
        },
        getFormData() {
            return {
                title: this.title,
                first_name: this.firstName,
                last_name: this.lastName,
                accountName: this.accountName,
                accountPhone: this.accountPhone ? !this.accountPhone.startsWith("+44") ? `+44${this.accountPhone}` : this.accountPhone : null,
                accountNumber: this.accountNumber,
                bankSortCode: this.bankSortCode,
                subBuildingNumberName: this.subBuildingNumberName,
                buildingNumberName: this.buildingNumberName,
                streetAddress: this.streetAddress,
                postcode: this.postCode,
                differentAddress: this.differentAddress,
            }
        },
        setErrors: function (errors) {
            let that = this;
            each(errors, function (v, k) {
                that.errors[k] = v
            });
        },
        clearErrors: function (){
            this.errors = Object.fromEntries(Object.entries(this.errors).map(v => [v[0], []]));
        }
    },
    mounted() {
        let that = this;
        api.property('latest').then(result => {
            that.currentAddress = result.data.data.currentPropertyAddress
            that.currentPostcode = result.data.data.currentPropertyPostcode
        })
    }
}
</script>

<style scoped lang="scss">
@import "../../sass/base";

.direct-debit {
    width: 136px;
    float: right;
}

.branch-code-segment {
    text-align: center;
}
</style>
